/** 4px base unit for the design-system spacing scale */
export const spacingUnit = 4 as const;

/**
 * Spacing scale in pixels, named like the Storybook scale (`spacing[8]` is 8px).
 * We use an 8px grid. `2` is the smallest step; every other step is a multiple of 4.
 */
export const spacing = {
  0: 0,
  2: 2,
  4: 4,
  8: 8,
  12: 12,
  16: 16,
  20: 20,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  64: 64,
  80: 80,
  96: 96,
} as const;

export type TSpacing = typeof spacing;
